<rt-dialog-body variant="default no-padding white" overflow-hidden>
  <div layout-vertical layout-full-width>
    <div class="header" layout-centered padding-small-x>
      <rt-badge
        *ngIf="hasBadge"
        color="scale"
        text="{{
          (featureData.plan === BillingPlanTier.Scale
            ? 'app.pricing.scale'
            : featureData.plan === BillingPlanTier.Lead
            ? 'app.pricing.lead'
            : ''
          ) | translate
        }}"
        text-scale-green
      >
      </rt-badge>
      <rt-heading variant="heading large" margin-left-small-x>
        <ng-container *ngIf="featureData.plan === BillingPlanTier.Launch">
          {{ 'app.pricing.feature_guard.available_in_launch' | translate }}
        </ng-container>
        <ng-container *ngIf="featureData.plan === BillingPlanTier.Scale">
          {{ 'app.pricing.feature_guard.available_in_scale' | translate }}
        </ng-container>
        <ng-container *ngIf="featureData.plan === BillingPlanTier.Lead">
          {{ 'app.pricing.feature_guard.available_in_lead' | translate }}
        </ng-container>
      </rt-heading>
    </div>
    <rt-feature-guard-content
      [featureData]="featureData"
      [canUpgrade]="canUpgrade"
      (openPlanPicker)="openPlanPicker()"
    >
    </rt-feature-guard-content>
  </div>
</rt-dialog-body>
